import React from 'react';
import {connect} from "react-redux";
import {Button, Divider, LinearProgress, Paper, Typography, withStyles} from "material-ui";
import {closeLoginFetch, initializeUsers, loginUser} from "../../redux/actions/users";
import {LoginForm} from "../../forms/login";

export class LoginContainer extends React.Component {

    componentDidMount() {
        this.props.initialize();
    };

    componentDidUpdate() {
        const {history} = this.props;
        if (localStorage.getItem('access-token') !== null) {
            history.push('/dashboard');
        }
    }

    handleSubmit = (values) => {
        this.props.loginUser(values);
    };

    onLoginButton = () => {
        this.refs.loginForm.submit();
    };

    render() {

        const {classes, isLoginFetch, isLoginError} = this.props;

        return (
            <div className={classes.root}>
                <Paper>
                    {isLoginFetch ? <LinearProgress/> : null}

                    <div className={classes.container}>
                        <Typography variant="headline">ログイン</Typography>
                        <Typography variant="caption">アカウント情報を入力してログインします</Typography>

                        {!isLoginFetch && isLoginError ?
                            <Typography variant="caption" color="error">アカウント情報が間違っています</Typography> : null}

                        <LoginForm
                            ref="loginForm"
                            errors={{}}
                            onSubmit={this.handleSubmit}/>

                    </div>
                    <Divider/>
                    <div className={classes.footer}>
                        <Button
                            onClick={this.onLoginButton}
                            color="primary">ログイン</Button>
                    </div>
                </Paper>
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        height: 'calc(100vh - 64px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    container: {
        padding: theme.spacing.unit * 3,
        width: 400,
    },
    footer: {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 3,
        paddingRight: theme.spacing.unit * 3,
        textAlign: 'right',
    },
});

LoginContainer = withStyles(styles)(LoginContainer);

LoginContainer = connect(
    (state) => {
        return {
            isLoginError: state.users.isLoginError,
            isLoginFetch: state.users.isLoginFetch,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(initializeUsers());
            },
            loginUser: (user) => {
                dispatch(loginUser(user)).then(() => {
                    setTimeout(() => {
                        dispatch(closeLoginFetch());
                    }, 300);
                });
            }
        }
    }
)(LoginContainer);


// WEBPACK FOOTER //
// ./src/containers/login/index.js